import React from 'react'
import { Provider } from 'react-redux'
import { persistor, store } from 'state/store'
import { PersistGate } from 'redux-persist/lib/integration/react'

const StoreProvider: React.FC = ({ children }) => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>{children}</PersistGate>
    </Provider>
  )
}

export default StoreProvider
